/** Which weekly sheet is printed: the blank form to fill in by hand, or the week's records. */
export const PrintMode = { Blank: 'blank', Filled: 'filled' } as const;
export type PrintMode = (typeof PrintMode)[keyof typeof PrintMode];
